<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>电视更新配置管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>

    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column prop="versionCode" label="版本号代码" width="120"></el-table-column>
      <el-table-column prop="versionName" label="版本名称" width="140"></el-table-column>
      <el-table-column prop="apkUrl" label="APK地址" min-width="260" show-overflow-tooltip></el-table-column>
      <el-table-column prop="forceUpdate" label="强制更新" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.forceUpdate == 1 ? 'danger' : 'info'">
            {{ scope.row.forceUpdate == 1 ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="启用状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status == 1 ? 'success' : 'info'">
            {{ scope.row.status == 1 ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="releaseNotes" label="更新说明" min-width="220" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteConfig(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="title" :visible.sync="editFormVisible" width="42%" @close="closeDialog">
      <el-form label-width="120px">
        <el-form-item label="版本号代码">
          <el-input size="small" v-model.number="formData.versionCode" placeholder="例如 201"></el-input>
        </el-form-item>

        <el-form-item label="版本名称">
          <el-input size="small" v-model="formData.versionName" placeholder="例如 2.0.1"></el-input>
        </el-form-item>

        <el-form-item label="APK地址">
          <el-input size="small" v-model="formData.apkUrl" placeholder="请输入完整 APK 下载地址"></el-input>
        </el-form-item>

        <el-form-item label="强制更新">
          <el-select size="small" v-model="formData.forceUpdate" placeholder="请选择">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="启用状态">
          <el-select size="small" v-model="formData.status" placeholder="请选择">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="更新说明">
          <el-input
            type="textarea"
            :rows="6"
            v-model="formData.releaseNotes"
            placeholder="请输入更新说明"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="addConfig()"
          v-if="title == '添加'">添加</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="updateConfig()"
          v-if="title == '修改'">修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addTvUpdateConfig,
  upTvUpdateConfig,
  deleteTvUpdateConfig,
  getTvUpdateConfigList
} from "../../api/userMG";

export default {
  data() {
    return {
      loading: false,
      editFormVisible: false,
      title: "添加",
      listData: [],
      formData: this.createEmptyForm()
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    createEmptyForm() {
      return {
        id: "",
        versionCode: "",
        versionName: "",
        apkUrl: "",
        releaseNotes: "",
        forceUpdate: 1,
        status: 1
      };
    },
    loadList() {
      this.loading = true;
      getTvUpdateConfigList({})
        .then((res) => {
          if (res.code == 200) {
            this.listData = (res.data && res.data.list) || [];
            return;
          }
          this.listData = [];
          this.$message.error(res.msg || "加载失败");
        })
        .catch((err) => {
          this.listData = [];
          const message =
            (err &&
              err.response &&
              err.response.data &&
              err.response.data.msg) ||
            (err && err.message) ||
            "加载失败，请稍后再试";
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleEdit(index, row) {
      this.editFormVisible = true;
      if (row) {
        this.title = "修改";
        this.formData = {
          id: row.id,
          versionCode: row.versionCode,
          versionName: row.versionName,
          apkUrl: row.apkUrl,
          releaseNotes: row.releaseNotes,
          forceUpdate: row.forceUpdate == null ? 1 : Number(row.forceUpdate),
          status: row.status == null ? 1 : Number(row.status)
        };
        return;
      }
      this.title = "添加";
      this.formData = this.createEmptyForm();
    },
    addConfig() {
      this.loading = true;
      addTvUpdateConfig(this.formData)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg || "添加成功");
            this.editFormVisible = false;
            this.loadList();
            return;
          }
          this.$message.error(res.msg || "添加失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateConfig() {
      this.loading = true;
      upTvUpdateConfig(this.formData)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg || "修改成功");
            this.editFormVisible = false;
            this.loadList();
            return;
          }
          this.$message.error(res.msg || "修改失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteConfig(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteTvUpdateConfig({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message.success(res.msg || "删除成功");
                this.loadList();
                return;
              }
              this.$message.error(res.msg || "删除失败");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    closeDialog() {
      this.editFormVisible = false;
      this.formData = this.createEmptyForm();
    }
  }
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/terrace/TvUpdateConfig.vue